module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-white overlay-background fixed top-0 left-0 h-100 w-100 z-2 flex justify-center"
  }, [_c('pl-button', {
    staticClass: "flex pl-secondary-font flex-column justify-center",
    staticStyle: {
      "height": "30px",
      "padding": "0 0 0 6px"
    },
    style: ({
      margin: _vm.centeredTitle ? '20px auto' : '20px 0px'
    }),
    nativeOn: {
      "click": function($event) {
        return _vm.closePage.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "pl-title"
  }, [_c('i', {
    staticClass: "ma1 fa fa-arrow-left"
  }), _vm._v("\n      Back\n    ")])]), _vm._v(" "), _c('article', {
    staticClass: "w-100 overflow-y-auto mt2"
  }, [_c('div', {
    staticClass: "w-100 center",
    style: ({
      'max-width': _vm.pageWidth
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "ph3 pv4"
  }, [_c('div', {
    staticClass: "center h-100",
    style: ({
      'max-width': _vm.pageWidth
    })
  }, [(_vm.loading) ? _c('div', [_c('pl-spinner', {
    staticClass: "x2",
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    }
  })], 1) : _vm._t("default")], 2)])]), _vm._v(" "), _c('button', {
    staticClass: "exit-comment-page ma2 top-0 right-0 flex justify-center middle-xs",
    class: {
      'shadow-1': _vm.hovered
    },
    staticStyle: {
      "margin": "5px 20px 0 20px"
    },
    on: {
      "click": _vm.closePage,
      "mouseenter": function($event) {
        _vm.hovered = true
      },
      "mouseleave": function($event) {
        _vm.hovered = false
      }
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "20px"
    },
    attrs: {
      "src": "/static/close.svg",
      "alt": "close"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "absolute italics",
    staticStyle: {
      "top": "65px"
    }
  }, [_vm._v("esc")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-925d9a50!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/fullscreenOverlay.vue
// module id = 912
// module chunks = 61